import styled from '@emotion/styled';
import {
  AccessTime as AccessTimeIcon,
  Block as BlockIcon,
  CheckCircleOutlineOutlined as CheckCircleOutlinedIcon,
} from '@mui/icons-material';
import { ChipProps } from '@mui/material';
import { rgba } from 'polished';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { StyledChip } from 'components/StyledChip';
import { TranslationNamespace } from 'i18n';
import { InternalTransfer, InternalTransferStatus } from 'types';

type Props = {
  internalTransfer: InternalTransfer;
};

const getBackgroundColor = (props: any) => {
  switch (props?.status) {
    case InternalTransferStatus.Completed:
      return props.theme.palette.success.main;
    case InternalTransferStatus.Cancelled:
      return props.theme.palette.error.main;
    case InternalTransferStatus.Active:
      return props.theme.palette.warning.main;
    default:
      return props.theme.palette.grey[500];
  }
};

const StyledLabel = styled(StyledChip)<
  ChipProps & { status: InternalTransferStatus }
>`
  background: ${(props) => rgba(getBackgroundColor(props), 0.1)};
`;

export const InternalTransferStatusLabel: React.FC<Props> = ({
  internalTransfer,
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.internal_transfers.status',
  });

  switch (internalTransfer.status) {
    case InternalTransferStatus.Completed:
      return (
        <StyledLabel
          label={t(internalTransfer.status)}
          status={internalTransfer.status}
          color="success"
          icon={<CheckCircleOutlinedIcon />}
        />
      );
    case InternalTransferStatus.Cancelled:
      return (
        <StyledLabel
          label={t(internalTransfer.status)}
          status={internalTransfer.status}
          color="error"
          icon={<BlockIcon />}
        />
      );
    case InternalTransferStatus.Active:
      return (
        <StyledLabel
          label={t(internalTransfer.status)}
          status={internalTransfer.status}
          color="warning"
          icon={<AccessTimeIcon />}
        />
      );
    default:
      return (
        <StyledLabel
          label={internalTransfer.status}
          status={internalTransfer.status}
        />
      );
  }
};
